import {createContext} from 'react';

const RegistroPagosOrdenCompraContext = createContext();

export default RegistroPagosOrdenCompraContext;